import type { FC } from 'react';
import { useMeasureElement } from '@wix/da-hooks/pkg/useMeasureElement/useMeasureElement';
import BaseList from '../BaseList';
import CommissionListItem from '../../items/CommissionListItem';
import { Props } from '../../StudioDeviationList';
import { StudioDeviationListContext } from '../../context';

import s from './CommissionDeviationList.scss';

const CommissionDeviationList: FC<Props> = ({ deviations }) => {
  const { ref: actionsColRef, dimensions: actionsDimensions } =
    useMeasureElement({
      throttle: 250,
      throttleOptions: { trailing: true },
    });
  return (
    <StudioDeviationListContext.Provider
      value={{
        actionsColRef,
        actionsColWidth:
          actionsDimensions.width && Math.floor(actionsDimensions.width),
      }}
    >
      <BaseList
        className={s['list']}
        results={deviations}
        renderItem={(deviation, idx) => (
          <CommissionListItem
            key={deviation.deviationId}
            deviation={deviation}
            offset={idx}
          />
        )}
      />
    </StudioDeviationListContext.Provider>
  );
};
CommissionDeviationList.displayName = 'CommissionDeviationList';

export default CommissionDeviationList;
